@if (changeTab$ | async) {}
@if (activeRoute$ | async; as active) {

  <div
    class="flex st-top-header-tabs"
    stHorizontalScrollDetection
    (hasHorizontalScroll)="onScrollChange($event)"
    [breakpoint]="active?.children?.length"
  >
    @if (active?.children && active?.children?.length) {
      @if (!singleTab()) {
        @for (tab of active?.children; track $index) {
          <st-top-header-tab
            [tabData]="tab"
            [active]="this.activeChild?.id === tab.id"
          ></st-top-header-tab>
        }
      } @else {
        <st-top-header-single-tab
          [navigationItem]="active"
        ></st-top-header-single-tab>
      }
    } @else {
      @if (standaloneTitle()) {
        <st-top-header-standalone-title
          [title]="standaloneTitle()"
        ></st-top-header-standalone-title>
      }
    }
  </div>

}

@if (!(activeRoute$ | async) && standaloneTitle()) {

  <div class="flex st-top-header-tabs">
    <st-top-header-standalone-title
      [title]="standaloneTitle()"
    ></st-top-header-standalone-title>
  </div>

}
